import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TRANSLATE, TranslatePipe} from '@brunata-angular/util';
import {InputSelectOptionGroupComponent} from '@brunata-angular/ui';
import {
    characterChoiceOptions,
    decimalSeparatorChoices,
    encodingChoiceOptions,
    exportEncodingChoices,
    ExportFileFormatForm,
    fieldSeparatorChoices,
    textDelimiterChoices,
} from '../../shared/models/export-file-format.model';
import {SettingsRowComponent} from './settings-row.component';

@Component({
    selector: 'app-characters-tab',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        TranslatePipe,
        InputSelectOptionGroupComponent,
        SettingsRowComponent,
    ],
    template: `
        <app-settings-row hintKey="customizedexports_export_fileformat_encoding_row_hint">
            <app-input-select-option-group
                sortOrder="original"
                [labelCols]="5"
                [formControl]="form().controls.encoding"
                [data]="encodingOptions()"
                [label]="
                    'customizedexports_export_fileformat_encoding_label'
                        | translate: 'online' : 'export'
                " />
        </app-settings-row>

        <app-settings-row hintKey="customizedexports_export_fileformat_field_separator_hint">
            <app-input-select-option-group
                sortOrder="original"
                [labelCols]="5"
                [formControl]="form().controls.fieldSeparator"
                [data]="fieldSeparatorOptions()"
                [label]="
                    'customizedexports_export_fileformat_field_separator_label'
                        | translate: 'online' : 'export'
                " />
        </app-settings-row>

        <app-settings-row hintKey="customizedexports_export_fileformat_text_delimiter_hint">
            <app-input-select-option-group
                sortOrder="original"
                [labelCols]="5"
                [formControl]="form().controls.textDelimiter"
                [data]="textDelimiterOptions()"
                [label]="
                    'customizedexports_export_fileformat_text_delimiter_label'
                        | translate: 'online' : 'export'
                " />
            <span hint-extra class="d-block text-danger">
                @if (form().hasError('separatorsCollide')) {
                    {{
                        'customizedexports_export_fileformat_delimiter_needed_hint'
                            | translate: 'online' : 'export'
                    }}
                }
            </span>
        </app-settings-row>

        <app-settings-row hintKey="customizedexports_export_fileformat_decimal_separator_hint">
            <app-input-select-option-group
                sortOrder="original"
                [labelCols]="5"
                [formControl]="form().controls.decimalSeparator"
                [data]="decimalSeparatorOptions()"
                [label]="
                    'customizedexports_export_fileformat_decimal_separator_label'
                        | translate: 'online' : 'export'
                " />
        </app-settings-row>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CharactersTabComponent {
    readonly form = input.required<ExportFileFormatForm>();

    private readonly translate = inject(TRANSLATE);

    protected readonly encodingOptions = computed(() =>
        encodingChoiceOptions(exportEncodingChoices, key =>
            this.translate(key, 'online', 'export'),
        ),
    );
    protected readonly fieldSeparatorOptions = computed(() =>
        characterChoiceOptions(fieldSeparatorChoices, key =>
            this.translate(key, 'online', 'export'),
        ),
    );
    protected readonly textDelimiterOptions = computed(() =>
        characterChoiceOptions(textDelimiterChoices, key =>
            this.translate(key, 'online', 'export'),
        ),
    );
    protected readonly decimalSeparatorOptions = computed(() =>
        characterChoiceOptions(decimalSeparatorChoices, key =>
            this.translate(key, 'online', 'export'),
        ),
    );
}
